const fontSizes = (size: FontSizeT) => {
  if (typeof size === "number") {
    return size;
  }
  switch (size) {
    case "xxs":
      return 10;
    case "xs":
      return 12;
    case "sm":
      return 13;
    case "md":
      return 14;
    case "lg":
      return 15;
    case "xl":
      return 16;
    case "xxl":
      return 17;
    case "xxxl":
      return 18;
    default:
      return 14;
  }
};

export { fontSizes };
